// eslint-disable-next-line @typescript-eslint/no-use-before-define
import React, { useRef } from 'react'
import { Info, BookOpen, PieChart,TrendingUp, Save } from 'react-feather'
import styled from 'styled-components'
import { ReactComponent as MenuIcon } from '../../assets/images/menu.svg'
import { useOnClickOutside } from '../../hooks/useOnClickOutside'
import useToggle from '../../hooks/useToggle'

import { ExternalLink } from '../../theme'

const StyledMenuIcon = styled(MenuIcon)`
  path {
    stroke: ${({ theme }) => theme.text1};
  }
`

const StyledMenuButton = styled.button`
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  height: 35px;
  background-color: ${({ theme }) => theme.bg3};

  padding: 0.15rem 0.5rem;
  border-radius: 0.5rem;

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    background-color: ${({ theme }) => theme.bg4};
  }

  svg {
    margin-top: 2px;
  }
`

const StyledMenu = styled.div`
  margin-left: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border: none;
  text-align: left;
`

const MenuFlyout = styled.span`
  min-width: 8.125rem;
  background-color: ${({ theme }) => theme.bg4};
  border: 1px solid white;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 0.5rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  position: absolute;
  top: 3rem;
  right: 0rem;
  z-index: 100;
`

const MenuItem = styled(ExternalLink)`
  flex: 1;
  padding: 0.5rem 0.5rem;
  color: ${({ theme }) => theme.text1};
  :hover {
    color: #e500d7;
    cursor: pointer;
    text-decoration: none;
  }
  > svg {
    margin-right: 8px;
  }
`

export default function Menu() {
  const node = useRef<HTMLDivElement>()
  const [open, toggle] = useToggle(false)

  useOnClickOutside(node, open ? toggle : undefined)

  return (
    <div ref={node as React.RefObject<HTMLDivElement>}>
      <StyledMenu>
        <StyledMenuButton onClick={toggle}>
          <StyledMenuIcon />
        </StyledMenuButton>
        {open && (
          <MenuFlyout>
            <MenuItem id="link" href="#/info">
              <Info size={14} />
              About
            </MenuItem>
            <MenuItem id="link" href="#/docs">
              <BookOpen size={14} />
              Docs
            </MenuItem>

            <MenuItem id="link" href="https://dexscreener.com/pulsechain/f:0x26594d3F4c172554A30D06e8fDc59229B860eAb0">
              <TrendingUp size={14} />
              Chart
            </MenuItem>
            <MenuItem id="link" href="#/burn">
              <Save size={14} />
              BURN
            </MenuItem>
            <MenuItem id="link-portfolio" href="#/portfolio">
              <PieChart size={14} />
              Portfolio
            </MenuItem>
          </MenuFlyout>
        )}
      </StyledMenu>
    </div>
  )
}
